module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/quick-icon-b.d2b288b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/quick-icon-b.png
// module id = y2rD
// module chunks = 3 5